export const buildMetricUnitMap = (metricConfig: any[]) => {
  const map: Record<string, string> = {};

  (metricConfig || []).forEach((item) => {
    if (item?.metric_name && item?.units) {
      map[item.metric_name] = item.units;
    }
  });

  return map;
};